import { render, staticRenderFns } from "./SetUrlBlocklist.vue?vue&type=template&id=35310a54&scoped=true&"
import script from "./SetUrlBlocklist.vue?vue&type=script&lang=js&"
export * from "./SetUrlBlocklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35310a54",
  null
  
)

export default component.exports